export default __webpack_public_path__ + "static/media/img8.a132ef7c.PNG";